var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTopUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0007 0.777771C12.4734 0.777771 13.6673 1.97168 13.6673 3.44444V8.1111C13.6673 8.4793 13.3689 8.77777 13.0007 8.77777H11.0007C9.52792 8.77777 8.33398 9.9717 8.33398 11.4444V12.1111C8.33398 12.4793 8.03552 12.7778 7.66732 12.7778H3.00065C1.52789 12.7778 0.333984 11.5838 0.333984 10.1111V9.1111H3.00065C4.28932 9.1111 5.33398 8.06644 5.33398 6.77777C5.33398 5.4891 4.28932 4.44444 3.00065 4.44444H0.333984V3.44444C0.333984 1.97168 1.52789 0.777771 3.00065 0.777771H11.0007ZM4.33398 6.77777C4.33398 6.04139 3.73703 5.44444 3.00065 5.44444H0.333984V8.1111H3.00065C3.73703 8.1111 4.33398 7.51417 4.33398 6.77777ZM10.6875 11.5218L11.1673 11.042V13.4444C11.1673 13.7206 11.3912 13.9444 11.6673 13.9444C11.9434 13.9444 12.1673 13.7206 12.1673 13.4444V11.042L12.6471 11.5218C12.8424 11.7171 13.1589 11.7171 13.3542 11.5218C13.5494 11.3266 13.5494 11.01 13.3542 10.8148L12.4923 9.95284C12.0367 9.49717 11.298 9.49717 10.8424 9.95284L9.98045 10.8148C9.78518 11.01 9.78518 11.3266 9.98045 11.5218C10.1757 11.7171 10.4923 11.7171 10.6875 11.5218Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopUp);
export default __webpack_public_path__ + "static/media/topUp.af13d054a139aa427ce21d9139a5a3f1.svg";
export { ForwardRef as ReactComponent };